export default __webpack_public_path__ + "static/media/ErrorIcon.28d3acea.svg";